module.exports = __webpack_public_path__ + "static/media/carousel4.d7003af0.png";